module.exports = __webpack_public_path__ + "img/kefuguanli.6c8e8662.png";